var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Customer_Feedback"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer_Feedback",
    "data-name": "Customer Feedback",
    clipPath: "url(#clip-Customer_Feedback)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat_icon",
    "data-name": "chat icon",
    d: "M44.4,631.9c-.219-.049-1.489-.964-1.7-.886l-.108.04a12.833,12.833,0,0,1-1.322.436.432.432,0,0,1-.1.01.647.647,0,0,1-.482-.187.731.731,0,0,1-.183-.552.454.454,0,0,1,.01-.082,9.764,9.764,0,0,1,.374-1.238.266.266,0,0,0-.027-.171l-.105-.206a5.568,5.568,0,0,1,2.3-7.442A5.336,5.336,0,0,1,45.562,621h.007a5.518,5.518,0,0,1-.005,11.033,5.321,5.321,0,0,1-1.164-.13Zm2.9-5.387a.644.644,0,1,1,.644.655A.65.65,0,0,1,47.3,626.517Zm-2.383,0a.644.644,0,1,1,.644.655.65.65,0,0,1-.644-.655h0Zm-2.388,0a.644.644,0,1,1,.644.656A.65.65,0,0,1,42.529,626.517Z",
    transform: "translate(-37.643 -618.501)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerFeedback);
export default __webpack_public_path__ + "static/media/Customer Feedback.058958612b1fe7cb4fd4c8ce1c5e526b.svg";
export { ForwardRef as ReactComponent };